import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Post } from "./../../models/post";
import { AngularFireDatabase } from "angularfire2/database";
import { OAuthService } from "app/services/o-auth";

@Component({
  selector: "app-post-info",
  templateUrl: "./post-info.component.html",
  styleUrls: ["./post-info.component.scss"],
})
export class PostInfoComponent implements OnInit {
  @Input() post: any;
  @Input() showAdmin: boolean;
  @Input() showActionButtons: boolean;
  @Output() onDelete: EventEmitter<Post>;

  public author: any;
  public reportedUser: any;

  constructor(private fireDatabase: AngularFireDatabase,
  private oAuthService: OAuthService) {
    this.onDelete = new EventEmitter();
  }

  ngOnInit() {
    if (this.post.author) {
      this.fireDatabase
        .object(`/users/${this.post.author}`)
        .subscribe((user: any) => {
          this.author = user;
        });
    }
    if (this.post.reportUserId) {
      this.fireDatabase
        .object(`/users/${this.post.reportUserId}`)
        .subscribe((user: any) => {
          this.reportedUser = user;
        });
    }
    if (this.post.mentioned) {
      this.post.mentionedCount = Object.keys(this.post.mentioned).length;
    } else {
      this.post.mentionedCount = 0;
    }
  }

  remove() {
    if (confirm(`Are you sure to delete post?`)) {
      this.fireDatabase.database
        .ref(`/server-process/post-to-remove/${this.post.$key}`)
        .set(this.post.author)
        .then(() => {
          this.fireDatabase.database.ref(`/user-portal-posts/`).child(this.post.userId).child(this.post.author).child(this.post.$key).set(null);
          this.onDelete.emit(this.post);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
